<template lang="pug">
  y-dialog(v-if="showDialog" v-model="showDialog" persistent fullscreen scrollable)
    v-card
      v-card-title.px-4(v-if="step === 0")
        v-btn(icon color="neutral700" @click="closeDialog")
          v-icon mdi-arrow-left
        v-spacer
        .text-md.font-semibold.ml-n4 Collect {{ loyaltySystem }}
        v-spacer
      v-divider(v-if="step === 0")
      v-card-text
        template(v-if="step === 0")
          collect-value(:loyaltySystem="loyaltySystem" :profile="profile" :purchased-value.sync="purchasedValue" :collect-value.sync="collectValue")
        template(v-else)
          value-collected(:loyaltySystem="loyaltySystem" :collected-data="valueCollectedData" @backToCollectPage="$emit('backToCollectPage')" @redeem="$emit('redeem')")
      v-card-actions
        v-btn.button-md.white--text(v-if="step === 0" block depressed color="neutral700" :loading="isLoading" @click="handleCollectValue") Collect {{ loyaltySystem }}
</template>

<script>
import CollectionProfile from "@/components/marketing/merchantapp/collect/CollectionProfile.vue";
import StampToCollect from "@/components/marketing/merchantapp/stamps/StampToCollect.vue";
import {mapActions, mapGetters} from "vuex";
import CollectValue from "@/components/marketing/merchantapp/collect/CollectValue.vue";
import ValueCollected from "@/components/marketing/merchantapp/collect/ValueCollected.vue";

export default {
  components: {
    ValueCollected,
    CollectValue,
    StampToCollect,
    CollectionProfile
  },
  props: {
    open: {
      type: Boolean,
    },
    loyaltySystem: {
      type: String,
      required: true
    },
    profile: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      step: 0,
      purchasedValue: null,
      collectValue: 1,
      isLoading: false,
      valueCollectedData: null
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    payload() {
      const payload = {
        collect_value: this.collectValue,
        type: this.loyaltySystem
      }
      if (this.purchaseValuePriceInteger()) {
        payload.purchased_value = this.purchaseValuePriceInteger()
      }
      return payload
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    closeDialog() {
      this.showDialog = false
      this.$emit('close')
    },
    purchaseValuePriceInteger() {
      const purchasedValue = this.purchasedValue
      if (!purchasedValue) return null
      return parseInt(parseFloat(purchasedValue).toFixed(this.$currency.exponent) * this.$currency.multiplier)
    },
    async handleCollectValue() {
      this.isLoading = true
      try {
        const url = `/loyalty/${this.company.slug}/members/${this.profile.id}/collects`
        const { data } = await this.$axios.post(url, this.payload)
        this.updateActivityLog(url, this.payload, data, 'POST', `Collect ${this.loyaltySystem}`, data.id)
        this.valueCollectedData = data
        this.$store.commit('marketing/setMember', data.member)
        this.step = 1
      }
      catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      }
      finally {
        this.isLoading = false
      }
    },
    updateActivityLog (endpoint, payload, response, method, activity, id) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: 'Collect stamp',
        activity: `Merchant-app: ${activity}`,
        raw_data: { endpoint, payload, response: response, method}
      }
      this.$axios.post('/users/logs', data)
          .catch(() => {})
    },
  },
}
</script>

<style scoped>
</style>
